<template>
  <div>
    <p v-if="insuranceData.retired" class="disclaimer-poppin">
      {{insuranceData.retiredStatement}}
    </p>
    <p v-else-if="insuranceData.overseas" class="disclaimer-poppin">
      {{insuranceData.overseasStatement}}
    </p>
    <p v-else-if="insuranceData.ftQualifiedIn2025" class="disclaimer-poppin">
      {{insuranceData.ftQualifiedIn2025Statement}}
    </p>
    <div v-if="this.component" class="mobile-target">
      <component v-touch:swipe="swipeHandler"
                 @hook:mounted="mountSections"
                 ref="comp"
                 v-bind:is="component"
                 :componentData="component.name === 'OptOutQuestion' ? insuranceData.optOut : insuranceData.regulatory"
                 @completed="confirm"
                 @returnToOptOut="returnToOptOut"
                 @regulatoryChanged="updateStoreWithRegulatory" />
    </div>
    <div id="component-buttons" v-if="!isMobile && insuranceData.overseasFtOrGbFtWhoQualifiedIn2025">
      <button v-on:click="confirm({process:'overseasFoundationTrainee'})" type="button" style="cursor:pointer" class="form-button next-button">
        {{insuranceData.nextButton}}
      </button>
    </div>
    <NextButton @clicked="navigateNext" />
  </div>
</template>
<script>
/* eslint-disable no-unused-expressions */
import OptOutQuestion from '@/insurance/OptOutQuestion.vue';
import RegulatoryQuestions from '@/insurance/RegulatoryQuestions.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import NextButton from '@/components/NextButton.vue';
import Manager from '../applicationManager';
import Mobile from '../mobile/mobile';
import insurance from './insurance';

export default {
  name: 'Insurance',
  components: {
    OptOutQuestion,
    RegulatoryQuestions,
    NextButton,
  },
  props: {
    backButton: HTMLAnchorElement,
    cancelBack: Boolean,
  },
  data() {
    return {
      comps: [
        OptOutQuestion,
        RegulatoryQuestions,
      ],
      component: null,
      optOutChanged: false,
      insuranceData: {},
    };
  },
  created() {
    this.insuranceData = insurance.insuranceData();
    this.component = this.insuranceData.initialComponent;
  },
  computed: {
    ...mapGetters(['isFinalSection', 'getInsurance']),
    ...mapState(['isMobile']),
  },
  watch: {
    cancelBack(update) {
      if (update) {
        this.loadOptOut();
      }
    },
  },
  methods: {
    ...mapActions(['savePliRegulatoryDataToStore', 'savePliOptOutData']),
    mountSections() {
      if (this.isMobile) {
        Mobile.initSections(this.$refs.comp.$el.querySelector('.application-section'));
      }
    },
    returnToOptOut(i) {
      this.savePliRegulatoryDataToStore(i);
      this.$refs.comp.$destroy();
      this.component = this.comps.find((comp) => comp === OptOutQuestion);
      if (this.isMobile) window.scrollTo(0, 0);
    },
    updateStoreWithRegulatory(i) {
      this.savePliRegulatoryDataToStore(i);
    },
    async navigateNext() {
      if (this.insuranceData.overseasFtOrGbFtWhoQualifiedIn2025) {
        await this.confirm({ process: 'OverseasFoundationTrainee' });
      } else if (this.isFinalSection) {
        this.$refs.comp.confirm();
      } else {
        this.swipeHandler('left', this.$refs.comp);
      }
    },
    SetIndexes(current, next) {
      this.sections[current].tab = -1;
      this.sections[next].tab = 0;
    },
    async confirm(data) {
      // we do a save to set true for opted out for all retired, overseas (members and fts) and 2025 gb qualified fts
      if (this.insuranceData.overseasFtOrGbFtWhoQualifiedIn2025 || this.insuranceData.regulatory.retiredOrOverseas) {
        const pli = this.getInsurance;
        this.savePliOptOutData(pli);
      }

      this.component = insurance.getNextComponent(data, this.insuranceData);
      if (!this.component) {
        this.$emit('saveInProgress', true);
        const result = await Manager.saveInsuranceDetails();

        const insuranceResult = {
          message: result.message,
          successful: result.successful,
          reloadForm: result.reloadForm || false,
        };

        this.$emit('completed', insuranceResult);
      }
      window.scroll(0, 20);
    },
    swipeHandler(direction) {
      Mobile.swipeHandler(direction, this.$refs.comp);
    },
    loadOptOut() {
      this.component = OptOutQuestion;
      window.scroll(0, 20);
      this.$emit('resetCancelBack', false);
    },
  },
};
</script>
<style lang="scss">
@import '../styles/_mixins.scss';
  div > p.disclaimer-poppin {
    @include DefaultPoppinFont();
  }

  .mobile-view div p.disclaimer-poppin {
    margin: 15px;
  }
</style>
